export const AppRoutes = {
  '403': '/403',
  '404': '/404',
  wc: '/wc',
  terms: '/terms',
  swap: '/swap',
  stake: '/stake',
  privacy: '/privacy',
  licenses: '/licenses',
  index: '/',
  imprint: '/imprint',
  home: '/home',
  cookie: '/cookie',
  addressBook: '/address-book',
  addOwner: '/addOwner',
  _offline: '/_offline',
  apps: {
    open: '/apps/open',
    index: '/apps',
    custom: '/apps/custom',
    bookmarked: '/apps/bookmarked',
  },
  balances: {
    nfts: '/balances/nfts',
    index: '/balances',
  },
  newSafe: {
    load: '/new-safe/load',
    create: '/new-safe/create',
    advancedCreate: '/new-safe/advanced-create',
  },
  settings: {
    setup: '/settings/setup',
    security: '/settings/security',
    notifications: '/settings/notifications',
    modules: '/settings/modules',
    index: '/settings',
    environmentVariables: '/settings/environment-variables',
    data: '/settings/data',
    cookies: '/settings/cookies',
    appearance: '/settings/appearance',
    safeApps: {
      index: '/settings/safe-apps',
    },
  },
  share: {
    safeApp: '/share/safe-app',
  },
  transactions: {
    tx: '/transactions/tx',
    queue: '/transactions/queue',
    msg: '/transactions/msg',
    messages: '/transactions/messages',
    index: '/transactions',
    history: '/transactions/history',
  },
  welcome: {
    index: '/welcome',
    accounts: '/welcome/accounts',
  },
  game: {
    index: '/game',
    board: '/game/board',
  },
  chat: {
    index: '/chat',
  },
}
